import { User } from './types';

export function filterUsersByNames<UserType extends User>(users: UserType[], value: string) {
	return users.filter((user) => {
		return [user.username, `${user.firstName ?? ''} ${user.lastName ?? ''}`].some((name = '') =>
			name.toLowerCase().includes(value.toLowerCase()),
		);
	});
}
